// extracted by mini-css-extract-plugin
export var sliderRange = "_o0-2";
export var sliderRoot = "_o0-0";
export var sliderThumb = "_o0-3";
export var sliderTrack = "_o0-1";